{
  "instances": {
    "details": {
      "label": "细节",
      "cache": {
        "hit_ratio": "命中率",
        "hits": "命中次数",
        "misses": "未命中",
        "size": "粒度"
      },
      "datasource": {
        "active_connections": "活动连接数",
        "min_connections": "最小连接数",
        "max_connections": "最大连接数",
        "title": "数据源: {dataSource}",
        "unlimited": "unlimited"
      },
      "gc": {
        "count": "总计",
        "time_spent_max": "最大耗时",
        "time_spent_total": "总耗时",
        "title": "垃圾回收"
      },
      "health": {
        "title": "健康",
        "toggle_details": "切换{name}健康详情"
      },
      "health_group": {
        "title": "健康组"
      },
      "info": {
        "no_info_provided": "未提供任何信息。",
        "title": "信息"
      },
      "memory": {
        "max": "最大",
        "metaspace": "初始空间",
        "size": "当前可用",
        "title": "内存",
        "used": "已用",
        "committed": "已提交"
      },
      "metadata": {
        "no_data_provided": "未提供元数据。",
        "title": "元数据"
      },
      "process": {
        "cpus": "CPU核心数",
        "pid": "进程ID",
        "parent_pid": "父进程ID",
        "owner": "所有者",
        "process_cpu_usage": "进程CPU使用率",
        "system_cpu_usage": "系统CPU使用率",
        "title": "进程",
        "uptime": "运行时间"
      },
      "threads": {
        "daemon": "守护线程",
        "live": "活动线程",
        "peak_live": "线程峰值",
        "title": "线程"
      }
    }
  }
}
